// extracted by mini-css-extract-plugin
export default {"highligth":"DashboardPage_highligth__OQffL"};